<template>
  <div>
    <section class="section feature-bg mb mt">
      <div class="container content">
        <div class="columns">
          <div class="column is-8-desktop is-offset-2-desktop has-text-white">
            <h1 class="h1 is-size-1 has-text-white">
              <span class="icon">
                <i class="far fa-frown"></i>
              </span>
            </h1>
            <p>Den här sidan finns inte eller har blivit flyttad.</p>
            <p>Felkod: 404</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },

  async created() {
    window.scrollTo(0, 0);
  },

  async mounted() {},
  destroyed() {},
  methods: {}
};
</script>
